import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export default function NoGuaranteeNotice({ className = "" }) {
  return (
    <div
      data-testid="no-guarantee-notice"
      className={`rounded-md border border-[#FF9F0A]/30 bg-[#FF9F0A]/[0.06] px-4 py-3 flex items-start gap-2.5 text-xs text-neutral-300 ${className}`}
    >
      <ShieldAlert className="h-4 w-4 text-[#FF9F0A] flex-shrink-0 mt-0.5" />
      <span className="leading-relaxed">
        <span className="text-white font-semibold">Vismarks is a visibility engine — not a guarantee of sales.</span>{" "}
        Results depend on demand, pricing, and product quality.{" "}
        <Link to="/legal" data-testid="no-guarantee-legal-link" className="text-[#007AFF] hover:underline">
          Read the full Legal Notice
        </Link>
      </span>
    </div>
  );
}
